// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time
import { endOfWeek, format } from "date-fns";

/**
 * Formats a week range string from a week start date
 * @param weekStartDate - The Sunday of the week
 * @returns Formatted string like "Jan 7, 2026 - Jan 13, 2026"
 */
export function formatWeekRange(weekStartDate: Date): string {
  const weekEndDate = endOfWeek(weekStartDate, { weekStartsOn: 0 });
  const startString = format(weekStartDate, "MMM d, yyyy");
  const endString = format(weekEndDate, "MMM d, yyyy");
  return `${startString} - ${endString}`;
}
